// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { ALREADY_HAS_ACTIVE_ACCOUNT } from 'actions/alreadyHasActiveAccount';
import { BANK_DECISION_MADE } from 'actions/bankDecisionMade';
import { CASH_REWARDS_ENROLLMENT_STATUS } from 'actions/cashRewardsEnrollmentStatus';
import { CREDIT_BANK_DECISION_MADE } from 'actions/creditBankDecisionMade';
import { CREDIT_DECLINED_BY_USER } from 'actions/creditDeclinedByUser';
import { CREDIT_ENROLLMENT_FAILED } from 'actions/creditEnrollmentFailed';
import { CREDIT_STATUS_CLEARED } from 'actions/creditStatusCleared';
import { ENROLLED_IN_CREDIT } from 'actions/enrolledInCredit';
import { ENROLLMENT_DECLINED } from 'actions/enrollmentDeclined';
import { ENROLLMENT_PENDING } from 'actions/enrollmentPending';
import { ENROLLMENT_RESET_VERIFY_EMAIL } from 'actions/enrollmentResetVerifyEmail';
import { ENROLLMENT_RESET_VERIFY_PHONE } from 'actions/enrollmentResetVerifyPhone';
import { ENROLLMENT_SUCCESSFUL } from 'actions/enrollmentSuccessful';
import { ENROLLMENT_USER_REVIEW } from 'actions/enrollmentUserReview';
import { ENROLLMENT_VERIFY_EMAIL } from 'actions/enrollmentVerifyEmail';
import { ENROLLMENT_VERIFY_PHONE } from 'actions/enrollmentVerifyPhone';
import { INVALID_EMAIL_CLEARED } from 'actions/invalidEmailCleared';
import { INVALID_EMAIL_SUBMITTED } from 'actions/invalidEmailSubmitted';
import { PROGRESS_CLEARED } from 'actions/progressCleared';
import { SUCCESS_ATTRIBUTION_SUBMITTED } from 'actions/successAttributionSubmitted';

import {
  CREDIT_DECLINED_BY_USER_STATE,
  CREDIT_ENROLLMENT_FAILED_STATE,
  CREDIT_SUCCESSFUL_STATE,
  ENROLLMENT_DECLINED_STATE,
  ENROLLMENT_PENDING_STATE,
  ENROLLMENT_SUCCESSFUL_STATE,
} from 'consts/enrollmentCompletionStates';

export const initialState = {
  status: null,
  invalidEmailSubmitted: false,
  creditStatus: null,
  successAttributionSubmitted: false,
  bank: null,
  creditBank: null,
  enrolledInCredit: false,
  requirePhoneVerification: false,
  requireEmailVerification: false,
  cashRewardsEnrollmentStatus: null,
};

/* eslint-disable default-case, no-param-reassign */
const enrollmentReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { type, payload } = action;
    switch (type) {
      case ALREADY_HAS_ACTIVE_ACCOUNT:
        draft.activeAccountEmail = payload.activeEmail;

        if (payload.loginToken) {
          draft.activeAccountLoginToken = payload.loginToken;
        }
        break;
      case ENROLLMENT_SUCCESSFUL:
        draft.status = ENROLLMENT_SUCCESSFUL_STATE;
        break;
      case ENROLLMENT_PENDING:
        draft.status = ENROLLMENT_PENDING_STATE;
        break;
      case ENROLLMENT_DECLINED:
        draft.status = ENROLLMENT_DECLINED_STATE;
        break;
      case ENROLLMENT_USER_REVIEW:
        draft.status = payload;
        break;
      case PROGRESS_CLEARED:
        return initialState;
      case INVALID_EMAIL_SUBMITTED:
        draft.invalidEmailSubmitted = true;
        break;
      case INVALID_EMAIL_CLEARED:
        draft.invalidEmailSubmitted = false;
        break;
      case CREDIT_STATUS_CLEARED:
        draft.creditStatus = null;
        break;
      case ENROLLED_IN_CREDIT:
        draft.enrolledInCredit = true;
        draft.creditStatus = CREDIT_SUCCESSFUL_STATE;
        break;
      case CREDIT_DECLINED_BY_USER:
        draft.creditStatus = CREDIT_DECLINED_BY_USER_STATE;
        break;
      case CREDIT_ENROLLMENT_FAILED:
        draft.creditStatus = CREDIT_ENROLLMENT_FAILED_STATE;
        break;
      case SUCCESS_ATTRIBUTION_SUBMITTED:
        draft.successAttributionSubmitted = true;
        break;
      case BANK_DECISION_MADE:
        draft.bank = payload.bank;
        break;
      case CREDIT_BANK_DECISION_MADE:
        draft.creditBank = payload.creditBank;
        break;
      case ENROLLMENT_VERIFY_PHONE:
        draft.requirePhoneVerification = true;
        if (payload) {
          draft.enrollmentRedirectEligible = payload.enrollmentRedirectEligible;
        }
        break;
      case ENROLLMENT_RESET_VERIFY_PHONE:
        draft.requirePhoneVerification = false;
        break;
      case ENROLLMENT_VERIFY_EMAIL:
        draft.requireEmailVerification = true;
        break;
      case ENROLLMENT_RESET_VERIFY_EMAIL:
        draft.requireEmailVerification = false;
        break;
      case CASH_REWARDS_ENROLLMENT_STATUS:
        draft.cashRewardsEnrollmentStatus = payload.cashRewardsEnrollmentStatus;
        break;
    }
  });

export default enrollmentReducer;
